module.exports = __webpack_public_path__ + "images/psp/SizeGuide/updated/small-self-5x5-25x200.svg";